import { getUserTimezone } from './getUserTimezone';

/**
 * Creates a tick mark formatter for chart time display
 */
export function createTickMarkFormatter(locale?: string, timezone?: string) {
  const tz = timezone || getUserTimezone();
  const fmt = new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: tz
  });

  return (time: number | { year: number; month?: number; day?: number }) => {
    const d =
      typeof time === 'number'
        ? new Date(time * 1000) // LWC uses seconds
        : new Date(time.year, (time.month ?? 1) - 1, time.day ?? 1);
    return fmt.format(d);
  };
}
